import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { isNil, isEmpty } from 'lodash';
import locale from 'antd/lib/date-picker/locale/el_GR';
import {
  Select,
  DatePicker,
  Row,
  Col,
  Table,
  Divider,
  Space,
  Tooltip,
  Spin,
  AutoComplete,
  Input,
  Modal,
  Slider,
} from 'antd';
import { ReactComponent as SearchIcon } from '../../../assets/icons/search_icon.gov.svg';
import { ReactComponent as ArrowIcon } from '../../../assets/icons/dropdown-arrow.svg';
import { ReactComponent as CalendarIcon } from '../../../assets/icons/calendar.gov.svg';
import {
  clearSayt,
  fetchProcessSAYT,
  fetchProcInstancesDetailed,
  getAllTaskNames,
  cancelProcessInstance,
  getActions,
  getBannerInfo,
  fetchRecords,
  clearApptrackDetails,
} from 'store/appTrack/actions';
import { ReactComponent as ActionsIcon } from '../../../assets/icons/more_dots.svg';
import { ReactComponent as FilterIcon } from '../../../assets/icons/filter_lines.svg';
import { ReactComponent as FilterIconBold } from '../../../assets/icons/filter_lines_bold.svg';
import ActionList from './components/ActionList';
import TableCell from './components/TableCell';
import { StatusTag } from 'components';
import { currencyFormatter, isBeneficiary, isUserStore } from 'utils';
import { getLocalString, localNames } from 'utils/localisation.service';
import { useNavigate } from 'react-router-dom';
import NoResults from './components/NoResults';
import { getSystemLocales, clearForm } from 'store/forms/actions';
import { setActiveFormId } from 'store/activeForm/actions';
import { checkUser, getUser, getTaxisData } from 'store/user/actions';
import { ReactComponent as CancelWarningIcon } from '../../../assets/icons/cancel_warning_icon.svg';
import { getFullDateTimeWithSeconds } from 'utils/helpers';
import { ReactComponent as ClearIcon } from '../../../assets/icons/clear-icon.svg';
import { ReactComponent as ApptrackSubmit } from '../../../assets/icons/apptrackSubmit.svg';

const AppTrackPage1 = () => {
  const viewMode = false;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedProcId, setSelectedProcId] = useState();
  const [isFiltersVisible, setFiltersVisible] = useState(false);
  const [filterImg, setFilterImg] = useState(<FilterIcon />);
  const user = useSelector(state => state.user);
  const userStatus = useSelector(state => state.user.status);
  const [saytOptions, setSaytOptions] = useState([]);
  //const saytOptions = useSelector(state => state.appTrack.sayt);
  const [detailedPayload, setDetailedPayload] = useState({ parameterList: [] });
  const privileges = useSelector(state => state.user.privileges);
  const groups = useSelector(state => state.user.groups);
  const [open, setOpen] = useState(false);
  const { Option } = Select;
  const { RangePicker } = DatePicker;
  const results = useSelector(state => state.appTrack.variables);
  const locales = useSelector(state => state.forms?.localeStrings);
  const loadingPage = useSelector(state => state.appTrack.loadingApptrack);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSizeFlag, setPageSizeFlag] = useState(5);
  const taskNames = useSelector(state => state.appTrack.taskNames);
  const sayt = useSelector(state => state.appTrack.sayt);
  const isProvider = user.groups
    ?.map(item => item.name)
    .includes('ProviderResourceGroup');
  const resultSize = useSelector(state => state.appTrack.resultSize);
  const [searchVar, setSearchvar] = useState('');
  const prefix = <SearchIcon style={{ marginRight: '14px' }} />;
  const suffix = (
    <ClearIcon
      onClick={() => setSearchvar('')}
      style={{ marginRight: '14px' }}
    />
  );
  const [cancelModal, setCancelModal] = useState(false);
  const [showSubmitModal, setShowSubmitModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);

  const loadingLocales = useSelector(state => state.forms.loadingLocales);
  const loadingTaxis = useSelector(state => state.user.loading);

  const dateFormat = 'DD/MM/YYYY';
  const filterText = isFiltersVisible ? 'filterText' : 'filterTextDefault';

  const cancelProcess = selectedProcId => {
    dispatch(cancelProcessInstance(selectedProcId, true)); // isEquipment = true
    setCancelModal(false);
  };

  useEffect(() => {
    if (!open) return;
    const handler = e => {
      const actionElement = e.target.closest('[data-action-id]');
      const clickedActionId = actionElement?.dataset.actionId;

      if (clickedActionId) {
        skipCloseRef.current = true;
        handleClose();
        return;
      }

      const actionListElement = e.target.closest(
        `#action-list-for-${selectedProcId}`
      );

      if (!actionListElement) {
        handleClose();
      }
    };

    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open, selectedProcId]);

  useEffect(() => {
    if (!loadingPage && !loadingTaxis && !loadingLocales && results) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [loadingPage, results, loadingLocales, loadingTaxis]);

  useEffect(() => {
    const shouldShowModal = localStorage.getItem('showAppTrackModal') == 'true';
    if (shouldShowModal) {
      setShowSubmitModal(true);
      localStorage.removeItem('showAppTrackModal');
    }
  }, []);

  useEffect(() => {
    const showModalUpdate = localStorage.getItem('showUpdateModal') == 'true';
    if (showModalUpdate) {
      setShowUpdateModal(true);
      localStorage.removeItem('showUpdateModal');
    }
  }, []);

  // useEffect(() => {
  //   const storedLanguage = localStorage.getItem('appLanguage');
  //   dispatch(getSystemLocales(storedLanguage));
  //   dispatch(checkUser(navigate));
  //   dispatch(getUser());
  //   dispatch(getTaxisData());
  //   dispatch(clearForm());
  //   // dispatch(fetchProcInstancesDetailedPaginated(detailedPayload,currentPage, pageSizeFlag));
  //   dispatch(getAllTaskNames());
  // }, [dispatch, navigate]);

  useEffect(() => {
    const storedLanguage = localStorage.getItem('appLanguage');
    dispatch(getSystemLocales(storedLanguage));
    dispatch(checkUser(navigate));
    dispatch(getUser());
    dispatch(getTaxisData());
    dispatch(clearForm());
    dispatch(clearApptrackDetails());
    // dispatch(fetchProcInstancesDetailed());
    // dispatch(fetchRecords(detailedPayload, currentPage, pageSizeFlag)); //empty param list
    dispatch(getAllTaskNames());
  }, [dispatch, navigate]);

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSizeFlag(pageSize);
    dispatch(fetchRecords(detailedPayload, page, pageSize)); //empty param list
  };

  useEffect(() => {
    if (!isEmpty(detailedPayload) && userStatus) setCurrentPage(1);
    dispatch(fetchRecords(detailedPayload, 1, pageSizeFlag));
  }, [detailedPayload]);

  const columns = [
    {
      title: 'Αρ. Αίτησης',
      dataIndex: 'businessKey',
      key: 'businessKey',
      render: (text, record) => {
        return (
          <TableCell
            id={`businessKey-cell-${record.businessKey}`}
            text={text}
          />
        );
      },
      sorter: {
        compare: (a, b) => a.businessKey - b.businessKey,
      },
      // width: 91,
      fixed: 'left',
    },
    {
      title: 'Α.Φ.Μ.',
      dataIndex: 'legalVat',
      key: 'legalVat',
      render: (text, record) => {
        return (
          <TableCell
            id={`businessKey-cell-${record.businessKey}`}
            text={text}
          />
        );
      },
      sorter: {
        compare: (a, b) => a.legalVat - b.legalVat,
      },
      width: 87,
      fixed: 'left',
    },
    {
      title: 'Επωνυμία',
      dataIndex: 'companyName',
      key: 'companyName',
      render: (text, record) => {
        return (
          <TableCell
            id={`businessKey-cell-${record.businessKey}`}
            text={text}
          />
        );
      },
      sorter: {
        compare: (a, b) => {
          // Check if both properties exist and are strings
          if (
            typeof a.companyName === 'string' &&
            typeof b.companyName === 'string'
          ) {
            return a.companyName.localeCompare(b.companyName);
          }

          // Handle cases where one or both properties don't exist or aren't strings
          if (
            typeof a.companyName !== 'string' &&
            typeof b.companyName === 'string'
          ) {
            return -1; // a comes first if b has valid activeTaskName but a doesn't
          }
          if (
            typeof a.companyName === 'string' &&
            typeof b.companyName !== 'string'
          ) {
            return 1; // b comes first if a has valid activeTaskName but b doesn't
          }
          return 0; // If neither a nor b have valid activeTaskName, treat them as equal
        },
      },
      width: 218,
      fixed: 'left',
    },
    {
      title: 'Status',
      dataIndex: 'activeTaskName',
      key: 'activeTaskName',
      render: (text, record) => {
        return (
          <StatusTag
            id={`activeTaskName-cell-${record.businessKey}`}
            status={text}
          />
        );
      },
      sorter: {
        compare: (a, b) => {
          // Check if both properties exist and are strings
          if (
            typeof a.activeTaskName === 'string' &&
            typeof b.activeTaskName === 'string'
          ) {
            return a.activeTaskName.localeCompare(b.activeTaskName);
          }

          // Handle cases where one or both properties don't exist or aren't strings
          if (
            typeof a.activeTaskName !== 'string' &&
            typeof b.activeTaskName === 'string'
          ) {
            return -1; // a comes first if b has valid activeTaskName but a doesn't
          }
          if (
            typeof a.activeTaskName === 'string' &&
            typeof b.activeTaskName !== 'string'
          ) {
            return 1; // b comes first if a has valid activeTaskName but b doesn't
          }
          return 0; // If neither a nor b have valid activeTaskName, treat them as equal
        },
      },
      // width: 135,
    },
    {
      title: 'Τόπος Επένδυσης',
      dataIndex: 'topos',
      key: 'topos',
      render: (text, record) => {
        return (
          <TableCell
            id={`businessKey-cell-${record.businessKey}`}
            text={text?.toUpperCase()}
          />
        );
      },
      sorter: {
        compare: (a, b) => {
          // Check if both properties exist and are strings
          if (typeof a.topos === 'string' && typeof b.topos === 'string') {
            return a.topos.localeCompare(b.topos);
          }

          // Handle cases where one or both properties don't exist or aren't strings
          if (typeof a.topos !== 'string' && typeof b.topos === 'string') {
            return -1; // a comes first if b has valid activeTaskName but a doesn't
          }
          if (typeof a.topos === 'string' && typeof b.topos !== 'string') {
            return 1; // b comes first if a has valid activeTaskName but b doesn't
          }
          return 0; // If neither a nor b have valid activeTaskName, treat them as equal
        },
      },
      // width: 126,
      fixed: 'left',
    },
    {
      title: 'Συνολικός Προϋπολογισμός',
      key: 'totalBudgetSum',
      render: (_, record) => {
        const total =
          (record.totalEstimate || 0) +
          (record.commercialLoan || 0) +
          (record.loan || 0);

        return (
          <TableCell
            id={`businessKey-cell-${record.totalBudget}`}
            text={total ? currencyFormatter(total) : '-'}
          />
        );
      },
      sorter: {
        compare: (a, b) => {
          const totalA =
            (a.totalEstimate || 0) + (a.commercialLoan || 0) + (a.loan || 0);
          const totalB =
            (b.totalEstimate || 0) + (b.commercialLoan || 0) + (b.loan || 0);
          return totalA - totalB;
        },
      },
      fixed: 'left',
      width: 100,
    },
    {
      title: 'Εμπορικό Δάνειο',
      dataIndex: 'commercialLoan',
      key: 'commercialLoan',
      render: (text, record) => {
        return (
          <TableCell
            id={`businessKey-cell-${record.commLoan}`}
            text={text ? currencyFormatter(text) : '-'}
          />
        );
      },
      sorter: {
        compare: (a, b) => {
          let valA =
            typeof a.commercialLoan === 'number' ? a.commercialLoan : 0;
          let valB =
            typeof b.commercialLoan === 'number' ? b.commercialLoan : 0;
          return valA - valB;
        },
      },
      // width: 133,
      fixed: 'left',
      width: 100,
    },
    {
      title: 'Δάνειο ΤΑΑ',
      dataIndex: 'loan',
      key: 'loan',
      render: (text, record) => {
        return (
          <TableCell
            id={`businessKey-cell-${record.rrfLoan}`}
            text={text ? currencyFormatter(text) : '-'}
          />
        );
      },
      sorter: {
        compare: (a, b) => {
          let valA = typeof a.loan === 'number' ? a.loan : 0;
          let valB = typeof b.loan === 'number' ? b.loan : 0;
          return valA - valB;
        },
      },
      // width: 100,
      fixed: 'left',
      width: 100,
    },
    {
      title: 'Υποβολή',
      dataIndex: 'submissionDate',
      key: 'submissionDate',
      render: (text, record) => {
        return (
          <TableCell
            id={`businessKey-cell-${record.submissionDate}`}
            text={getFullDateTimeWithSeconds(text)}
          />
        );
      },
      sorter: {
        compare: (a, b) => {
          if (a.submissionDate && b.submissionDate) {
            return new Date(a.submissionDate) - new Date(b.submissionDate);
          } else if (!a.submissionDate && b.submissionDate) {
            return -1;
          } else if (a.submissionDate && !b.submissionDate) {
            return 1;
          } else {
            return 0;
          }
        },
      },
      // width: 91,
      fixed: 'left',
    },
    {
      title: '',
      fixed: 'right',
      key: 'action',
      align: 'right',
      render: (text, record) => {
        return (
          <Space
            id={`action-cell-${record.businessKey}`}
            align="end"
            style={{ width: 'auto', marginRight: '2rem' }}
          >
            <Tooltip title="Actions">
              <ActionsIcon
                aria-describedby={id}
                data-action-id={record.id}
                onClick={e => onMoreClick(record.id, record.businessKey)(e)}
                style={{ cursor: 'pointer' }}
              />
            </Tooltip>
          </Space>
        );
      },
    },
  ];

  const id = open ? 'simple-popover' : undefined;

  useEffect(() => {
    const intervalId = setInterval(() => {
      dispatch(checkUser(navigate));
    }, process.env.REACT_APP_SESSION_CHECK_TIME);
    return () => clearInterval(intervalId);
  }, []);

  const [popoverPos, setPopoverPos] = useState(null);
  const skipCloseRef = React.useRef(false);

  const onMoreClick = (id, b_key) => event => {
    if (skipCloseRef.current) {
      skipCloseRef.current = false;
      return;
    }

    setSelectedProcId(id);
    dispatch(setActiveFormId(id));

    const cell = event.currentTarget.closest('td') || event.currentTarget;
    const rect = cell.getBoundingClientRect();

    setPopoverPos({
      top: rect.top + 70,
      left: rect.right + 50,
    });

    dispatch(getActions(id)).then(() => {
      setOpen(true);
    });
  };

  const handleClose = () => {
    setOpen(false);
    setPopoverPos(null);
  };

  const renderTitle = title => <span>{title}</span>;

  const renderItem = title => ({
    value: title,
    label: (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        {title}
      </div>
    ),
  });

  useEffect(() => {
    if (sayt && !isEmpty(sayt)) {
      Object.values(sayt).map(key => {
        const opt = { options: [] };
        if (key?.name != 'limitExceeded') {
          if (key?.name == 'legalVat') {
            opt.label = renderTitle('Α.Φ.Μ.');
          } else if (key?.name == 'businessKey') {
            opt.label = renderTitle('Αρ Αίτησης');
          } else if (key?.name == 'companyName') {
            opt.label = renderTitle('Επωνυμία');
          }
          const uniqueValues = new Set();

          for (let value of key?.values) {
            if (!uniqueValues.has(value.value)) {
              uniqueValues.add(value.value);
              opt.options.push(renderItem(value.value));
            }
          }
          saytOptionsTmp.push(opt);
        }
        setSaytOptions(saytOptionsTmp);
      });
    } else {
      setSaytOptions([]);
    }
  }, [sayt]);

  const onSAYTSelect = value => {
    const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));
    // detailedPayloadTmp["saytKey"] = value;
    // setDetailedPayload(detailedPayloadTmp);
    if (!isNil(value)) {
      if (
        detailedPayloadTmp.parameterList
          .map(i => i.qualifier.includes('sayt'))
          .includes(true)
      ) {
        const filteredList = detailedPayloadTmp.parameterList.map(obj => {
          if (obj.qualifier === 'sayt') {
            return { ...obj, value: value };
          } else {
            return { ...obj };
          }
        });

        const parameterList = {
          parameterList: filteredList,
        };
        setDetailedPayload(parameterList);
      } else {
        detailedPayloadTmp.parameterList.push({
          qualifier: 'sayt',
          type: 'STRING_VALUE',
          value: value,
        });
        setDetailedPayload(detailedPayloadTmp);
      }
    } else {
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== 'sayt'
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const onSAYTSearch = value => {
    const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));
    if (!isNil(value)) {
      if (
        detailedPayloadTmp.parameterList
          .map(i => i.qualifier.includes('sayt'))
          .includes(true)
      ) {
        const filteredList = detailedPayloadTmp.parameterList.map(obj => {
          if (obj.qualifier === 'sayt') {
            return { ...obj, value: value };
          } else {
            return { ...obj };
          }
        });

        const parameterList = {
          parameterList: filteredList,
        };
        setDetailedPayload(parameterList);
      } else {
        detailedPayloadTmp.parameterList.push({
          qualifier: 'sayt',
          type: 'STRING_VALUE',
          value: value,
        });
        setDetailedPayload(detailedPayloadTmp);
      }
    } else {
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== 'sayt'
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const onSAYTChange = value => {
    if (value.length == 0) {
      dispatch(clearSayt());
      setSaytOptions([]);
      const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));
      // delete detailedPayloadTmp.saytKey;
      // setDetailedPayload(detailedPayloadTmp);
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== 'sayt'
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const saytOptionsTmp = [];

  const handleSAYT = value => {
    if (value.length >= 3) {
      dispatch(fetchProcessSAYT(value));
    }
  };

  const toggleFilters = () => {
    setFiltersVisible(prev => {
      const next = !prev;
      setFilterImg(next ? <FilterIconBold /> : <FilterIcon />);
      return next;
    });
  };

  const overFilter = () => {
    setFilterImg(<FilterIconBold />);
  };

  const outFilter = () => {
    if (isFiltersVisible) {
      setFilterImg(<FilterIconBold />);
    } else {
      setFilterImg(<FilterIcon />);
    }
  };

  const onStatusChange = value => {
    const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));
    // console.log(detailedPayloadTmp, value)
    if (!isNil(value)) {
      if (
        detailedPayloadTmp.parameterList
          .map(i => i.qualifier.includes('parseFlag'))
          .includes(true)
      ) {
        const filteredList = detailedPayloadTmp.parameterList.map(obj => {
          if (obj.qualifier === 'parseFlag') {
            return { ...obj, value: value };
          } else {
            return { ...obj };
          }
        });

        const parameterList = {
          parameterList: filteredList,
        };
        setDetailedPayload(parameterList);
      } else {
        detailedPayloadTmp.parameterList.push({
          qualifier: 'parseFlag',
          type: 'BOOLEAN',
          value: value,
        });
        setDetailedPayload(detailedPayloadTmp);
      }
    } else {
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== 'parseFlag'
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const onFilterChange = (value, qualifier, type) => {
    const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));

    if (!isNil(value)) {
      if (
        detailedPayloadTmp.parameterList
          .map(i => i.qualifier.includes(qualifier))
          .includes(true)
      ) {
        const filteredList = detailedPayloadTmp.parameterList.map(obj => {
          if (obj.qualifier === qualifier) {
            return { ...obj, value: value };
          } else {
            return { ...obj };
          }
        });

        const parameterList = {
          parameterList: filteredList,
        };
        setDetailedPayload(parameterList);
      } else {
        detailedPayloadTmp.parameterList.push({
          qualifier: qualifier,
          type: type,
          value: value,
        });
        setDetailedPayload(detailedPayloadTmp);
      }
    } else {
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== qualifier
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const onDateRangeChange = (value, dateString) => {
    const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));

    if (!isNil(value)) {
      if (!isEmpty(dateString[0]) && !isEmpty(dateString[1])) {
        const filteredList = detailedPayloadTmp.parameterList.map(obj => {
          if (obj.qualifier === 'custom_submission_date') {
            return { ...obj, from: dateString[0], to: dateString[1] };
          } else {
            return { ...obj };
          }
        });

        const parameterList = {
          parameterList: filteredList,
        };
        setDetailedPayload(parameterList);
      } else {
        detailedPayloadTmp.parameterList.push({
          qualifier: 'custom_submission_date',
          type: 'RANGE_DATE',
          from: dateString[0],
          to: dateString[1],
        });
        setDetailedPayload(detailedPayloadTmp);
      }
    } else {
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== 'custom_submission_date'
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const onSliderChange = value => {
    const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));

    if (!isNil(value)) {
      const index = detailedPayloadTmp.parameterList.findIndex(
        obj => obj.qualifier === 'loanPercentage'
      );

      if (!isNil(value[0]) && !isNil(value[1])) {
        if (index !== -1) {
          detailedPayloadTmp.parameterList[index].from = value[0];
          detailedPayloadTmp.parameterList[index].to = value[1];
        } else {
          detailedPayloadTmp.parameterList.push({
            qualifier: 'loanPercentage',
            type: 'RANGE_INTEGER',
            from: value[0],
            to: value[1],
          });
        }

        setDetailedPayload(detailedPayloadTmp);
      } else {
        detailedPayloadTmp.parameterList.push({
          qualifier: 'loanPercentage',
          type: 'RANGE_INTEGER',
          from: value[0],
          to: value[1],
        });
        setDetailedPayload(detailedPayloadTmp);
      }
    } else {
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== 'loanPercentage'
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const Auditormarks = {
    100: '100%',
    0: '0%',
  };

  return (
    //    loadingTaxis || loadingLocales ?
    //   <div className="custom-spinner">
    //   <div>
    //     <Spin size="large" />
    //   </div>
    // </div>
    //   :
    <main>
      <Modal
        id={`cancel-modal-${selectedProcId}`}
        centered
        width={400}
        open={cancelModal}
        className={`custom-modal`}
        onCancel={() => setCancelModal(false)}
        onOk={() => setCancelModal(false)}
        closable={false}
        footer={null}
      >
        <div className="image_modal">
          <CancelWarningIcon />
        </div>
        <div className="modal_info">
          <h3>Επιβεβαίωση Ακύρωσης Αίτησης</h3>
          <p>Είστε σίγουροι ότι επιθυμείτε να ακυρώσετε την αίτησή σας;</p>
          <p>Προσοχή η ενέργεια είναι μη αναστρέψιμη.</p>
        </div>
        <div className="footerBtnContainer">
          <button
            id={'cancel-modal-cancel-button'}
            className="cancel-btn-assign"
            onClick={() => setCancelModal(false)}
          >
            Επιστροφή
          </button>
          <button
            id={`cancel-modal-ok-button-${selectedProcId}`}
            onClick={() => cancelProcess(selectedProcId)}
            className="btn-assign"
          >
            Επιβεβαίωση
          </button>
        </div>
      </Modal>
      <Modal
        id={`after-submit-modal-${selectedProcId}`}
        centered
        width={400}
        open={showSubmitModal}
        className={`custom-modal`}
        onCancel={() => setShowSubmitModal(false)}
        onOk={() => setShowSubmitModal(false)}
        closable={false}
        footer={null}
      >
        <div className="image_modal">
          <ApptrackSubmit />
        </div>
        <div className="modal_info">
          <h3>Η αίτησή σας υποβλήθηκε με επιτυχία.</h3>
          <p>
            Το Business Plan σας δημιουργείται αυτόματα και θα προωθηθεί στο
            Center of Excellence.
          </p>
          <p>Θα λάβετε σχετική ενημέρωση για τα επόμενα βήματα.</p>
        </div>
        <div className="footerBtnContainer">
          <button
            id={'cancel-modal-cancel-button'}
            className="cancel-btn-assign"
            onClick={() => setShowSubmitModal(false)}
          >
            Επιστροφή
          </button>
        </div>
      </Modal>
      <Modal
        id={`after-submit-modal-${selectedProcId}`}
        centered
        width={400}
        open={showUpdateModal}
        className={`custom-modal`}
        onCancel={() => setShowUpdateModal(false)}
        onOk={() => setShowUpdateModal(false)}
        closable={false}
        footer={null}
      >
        <div className="image_modal">
          <ApptrackSubmit />
        </div>
        <div className="modal_info">
          <h3>Η ενημέρωση του αρχείου ήταν επιτυχής.</h3>
          <p>
            Παρακαλώ περιμένετε μερικά λεπτά για την επαναδημιουργία του
            Επενδυτικού Σχεδίου.
          </p>
        </div>
        <div className="footerBtnContainer">
          <button
            id={'cancel-modal-cancel-button'}
            className="cancel-btn-assign"
            onClick={() => setShowUpdateModal(false)}
          >
            Επιστροφή
          </button>
        </div>
      </Modal>
      <div>
        {open && popoverPos && (
          <div
            style={{
              top: popoverPos.top,
              left: popoverPos.left,
            }}
            className="action-popover"
          >
            <ActionList
              open={setOpen}
              id={selectedProcId}
              payload={detailedPayload}
              setCancelModal={setCancelModal}
            />
          </div>
        )}
      </div>
      <div style={{ marginTop: '30px', marginBottom: '21px' }}>
        {privileges?.includes('CanRenderSAYT') && (
          <div style={{ marginTop: '30px', marginBottom: '21px' }}>
            <AutoComplete
              popupClassName="certain-category-search-dropdown"
              dropdownMatchSelectWidth={500}
              style={{ width: '100%' }}
              options={saytOptions}
              onSearch={handleSAYT}
              onSelect={onSAYTSelect}
              onChange={onSAYTChange}
              defaultValue={detailedPayload?.saytKey}
            >
              <Input.Search
                id="autocomplete-search-input"
                onSearch={onSAYTSearch}
                bordered={false}
                allowClear={true}
                prefix={prefix}
                className="sayt-input-filter input-filter"
                size="large"
                // placeholder={getLocalString(
                //   locales,
                //   isKTP ? localNames.HOME_PAGE_SEARCHKTP :
                //   isBeneficiary(groups) ? localNames.HOME_PAGE_SEARCHNP :
                //   ''
                // )}
                placeholder="Αναζήτηση με Α.Φ.Μ., Αρ. Αίτησης, Επωνυμία"
                enterButton
              />
            </AutoComplete>
          </div>
        )}
      </div>
      {privileges?.includes('CanRenderAppFilters') && (
        <div>
          <Tooltip placement="right" title="Expanded Filters">
            <Space
              id="filters-toggle-button"
              onClick={() => toggleFilters()}
              onMouseEnter={() => overFilter()}
              onMouseLeave={() => outFilter()}
              className="filterButton mt-3"
            >
              {filterImg}
              <span className={filterText}>
                {getLocalString(locales, localNames.HOME_PAGE_FILTERSBUTTON)}
              </span>
            </Space>
          </Tooltip>

          {isFiltersVisible && (
            <div className="filtersContainer">
              <div className="filters-wrapper">
                <div style={{ flex: '1' }}>
                  <Select
                    id="select-application-status"
                    suffixIcon={<ArrowIcon />}
                    className="input-filter"
                    style={{ width: '100%' }}
                    dropdownAlign={{ offset: [-11, 5] }}
                    showSearch
                    allowClear={true}
                    placeholder={
                      getLocalString(
                        locales,
                        localNames?.HOME_PAGE_FILTERS_STATUS
                      ) || 'Status'
                    }
                    optionFilterProp="children"
                    onChange={onStatusChange}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    <Option value={false}>Center of Excellence</Option>
                    <Option value={true}>
                      Center of Excellence BP Pending
                    </Option>
                  </Select>
                </div>

                <div style={{ flex: '1' }}>
                  <RangePicker
                    id="application-results-date-range-picker-from"
                    locale={{
                      ...locale,
                      lang: {
                        ...locale.lang,
                        rangePlaceholder: [
                          getLocalString(
                            locales,
                            localNames.HOME_PAGE_FILTERS_DATEFROM
                          ),
                          getLocalString(
                            locales,
                            localNames.HOME_PAGE_FILTERS_DATETO
                          ),
                        ],
                      },
                    }}
                    format={dateFormat}
                    suffixIcon={<CalendarIcon />}
                    allowEmpty={[true, true]}
                    onCalendarChange={onDateRangeChange}
                    className="input-filter"
                    style={{ width: '100%', height: 'unset !important' }}
                  />
                </div>
                <div style={{ flex: '1' }} className="slider-wrapper">
                  <span className="slider-label-expenditure">
                    % Συμμετοχής ΤΑΑ στη Δαπάνη
                  </span>
                  <Slider
                    className="sliderexpenditure"
                    max={100}
                    min={0}
                    step={1}
                    marks={Auditormarks}
                    onAfterChange={onSliderChange}
                    range
                    defaultValue={[0, 100]}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      )}
      <Divider></Divider>
      {loadingPage && (
        <div className="custom-spinner">
          <div>
            <Spin
              id="apptrack-application-results-table-spinner"
              size="default"
            />
          </div>
        </div>
      )}
      {!loadingPage && (
        <Row gutter={32}>
          <Col span={24}>
            {!isEmpty(results) && (
              <div>
                <Table
                  scroll={{ x: true }}
                  id="apptrack-application-results-table"
                  className="results-table"
                  dataSource={results}
                  columns={columns}
                  rowKey="id"
                  pagination={{
                    total: resultSize,
                    current: currentPage,
                    showSizeChanger: true,
                    showTitle: true,
                    pageSizeOptions: [5, 10, 20, 50, 100, 200],
                    pageSize: pageSizeFlag,
                    onChange: (page, pageSize) => {
                      console.log('page, pageSize', page, pageSize);
                      handlePageChange(page, pageSize);
                    },
                  }}
                />
              </div>
            )}
          </Col>
        </Row>
      )}

      {isEmpty(results) && (
        <NoResults
          id="apptrack-application-results-no-results"
          description={'Δε βρέθηκαν αποτελέσματα'}
          subDescription={''}
        />
      )}
    </main>
  );
};

export default AppTrackPage1;
